import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a4409d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "menu pb-2 pb-lg-4 pt-5" }
const _hoisted_3 = { class: "m-0 p-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "fs-8" }
const _hoisted_7 = {
  class: "accordion accordion-flush",
  id: "accordionFlushExample"
}
const _hoisted_8 = {
  key: 0,
  class: "accordion-item"
}
const _hoisted_9 = {
  class: "accordion-header",
  id: "flush-headingOne"
}
const _hoisted_10 = ["data-bs-target", "aria-controls"]
const _hoisted_11 = { class: "icon-div d-flex justify-content-center align-items-center me-2" }
const _hoisted_12 = ["src"]
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "fs-8" }

import { menu_admin } from '@/constants/index'
import { COMMUNITY_STORE } from '@/store/constants'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  showTags: {
    type: Boolean,
    default: true,
  },
  showUser: {
    type: Boolean,
    default: false,
  },
  showGroup: {
    type: Boolean,
    default: false,
  },
},
  emits: ['onClickMenuChild'],
  setup(__props, { emit }) {

const route = useRoute()

const store = useStore()
const dataCommunity = computed(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])




const onClickMenu = () => {
  emit('onClickMenuChild', false)
}

const isInCommunitySiteActive = (item) => {
  return item?.id === 25 && ['CK10', 'CK20', 'CK30', 'CM10', 'CM20'].includes(route?.meta?.screenId ?? '')
}

const isInCommunitySiteExpanded = (menu) => {
  return menu?.id === 24 && ['CK10', 'CK20', 'CK30', 'CM10', 'CM20'].includes(route?.meta?.screenId ?? '')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu_admin), (menu) => {
          return (_openBlock(), _createElementBlock("li", {
            key: menu.id
          }, [
            (!menu.accordion)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: menu.to(_unref(route), _unref(route)?.params?.id),
                  class: "d-flex fs-6 align-items-center w-100 link-no-accordion text-black text-decoration-none",
                  onClick: onClickMenu
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: menu.icon,
                      class: "icon me-2 d-flex justify-content-center align-items-center"
                    }, null, 8, _hoisted_4),
                    _createElementVNode("img", {
                      src: menu.activeIcon,
                      class: "active-icon invisible position-absolute d-flex justify-content-center align-items-center"
                    }, null, 8, _hoisted_5),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(menu.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (menu.accordion && (menu.id != 24 || (menu.id == 24 && _unref(dataCommunity).community_site_available)))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("h2", _hoisted_9, [
                      _createElementVNode("button", {
                        class: _normalizeClass([
                    'accordion-button fs-8 ',
                    isInCommunitySiteExpanded(menu)
                      ? ''
                      : menu.items.filter((e) => _unref(route).path.includes(e.to(_unref(route), _unref(route)?.params?.id).split('?')[0])).length > 0
                      ? ''
                      : 'collapsed',
                  ]),
                        type: "button",
                        name: "accordion",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": `#${menu.title}`,
                        "aria-expanded": "true",
                        "aria-controls": menu.title
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            src: menu.icon,
                            class: "icon d-flex justify-content-center align-items-center"
                          }, null, 8, _hoisted_12)
                        ]),
                        _createTextVNode(" " + _toDisplayString(menu.title), 1)
                      ], 10, _hoisted_10)
                    ]),
                    _createElementVNode("div", {
                      id: menu.title,
                      class: _normalizeClass([
                  'accordion-collapse collapse',
                  isInCommunitySiteExpanded(menu) ? 'show' : '',
                  menu.items.filter((e) => _unref(route).path.includes(e.to(_unref(route), _unref(route)?.params?.id).split('?')[0])).length > 0 ? 'show' : '',
                ]),
                      "aria-labelledby": "flush-headingOne",
                      "data-bs-parent": "#accordionFlushExample"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.items, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.id,
                          class: "item-menu"
                        }, [
                          _createVNode(_component_router_link, {
                            to: item.to(_unref(route), _unref(route)?.params?.id),
                            onClick: onClickMenu,
                            class: _normalizeClass(["d-flex fs-6 align-items-center w-100 text-black text-decoration-none", isInCommunitySiteActive(item) ? 'router-link-active' : ''])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"])
                        ]))
                      }), 128))
                    ], 10, _hoisted_13)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})